import globalParams from "@/CommonDP/utils/globalParams";
import { isFunction } from "lodash";
/**
 * 用于注册流程的表单
 * @param {} formKey
 * @param {*} formComponent
 * @param {*} isH5 是否是H5的流程
 */
export function registerFlowForm(formKey, formComponent, isH5) {
  if (!isH5) {
    const comObj = globalParams.get(`flow.form.${formKey}`);
    comObj ? "" : globalParams.set(`flow.form.${formKey}`, formComponent);
  } else {
    const comObjH5 = globalParams.get(`flow.formH5.${formKey}`);
    comObjH5 ? "" : globalParams.set(`flow.formH5.${formKey}`, formComponent);
  }
}

export function getFormComponent(formKey, isH5) {
  let component;
  if (!isH5) {
    component = globalParams.get(`flow.form.${formKey}`, null);
  } else {
    component = globalParams.get(`flow.formH5.${formKey}`, null);
  }
  // console.log("getFormComponent", component);
  // if(isFunction(component)){
  //   const b= component();
  // }
  return component ;
}

export function getFormRequest() {
  return globalParams.get(`flow.formRequest`);
}

export const getNewFormRequest = () => {
  return globalParams.get(`flow.formRequest`);
};
export function getDetailFormComponent(formKey) {
  return globalParams.get(`flow.form.${formKey}:detail`, null);
}
export function getApprovalFormComponent(formKey) {
  return globalParams.get(`flow.form.${formKey}:approval`, null);
}
/**
 * 注册标准的表单组件
 */
export function registerStdFlowForm() {
  console.log("registerStdFlowForm");
  const commonFlowForm = () => import(/* webpackChunkName:'baseFlowForm' */ "../form/commonFlowForm.vue");
  const tz = () => import(/* webpackChunkName:'baseFlowForm' */ "../form/tz.vue");
  const check = () => import(/* webpackChunkName:'baseFlowForm' */ "../form/check/index.vue");
  const publish = () => import(/* webpackChunkName:'baseFlowForm' */ "../form/publish.vue");
  const customVform = () => import(/* webpackChunkName:'baseFlowForm' */ "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue");
  const commonH5 = () => import(/* webpackChunkName:'baseFlowForm' */ "../formH5/commonH5.vue");
  const tzH5 = () => import(/* webpackChunkName:'baseFlowForm' */ "../formH5/tzH5.vue");
  const checkH5 = () => import(/* webpackChunkName:'baseFlowForm' */ "../formH5/checkH5.vue");
  const publishH5 = () => import(/* webpackChunkName:'baseFlowForm' */ "../formH5/publishH5.vue");
  const leaveH5 = () => import(/* webpackChunkName:'baseFlowForm' */ "@/CommonDP/pages/mainMg/project/approvalFlowH5/modules/leave.vue");
  registerFlowForm("common", commonFlowForm);
  registerFlowForm("tz", tz);
  registerFlowForm("check", check);
  registerFlowForm("publish", publish);

  registerFlowForm("common", commonH5, true);
  registerFlowForm("tz", tzH5, true);
  registerFlowForm("check", checkH5, true);
  registerFlowForm("publish", publishH5, true);
  registerFlowForm("leave", leaveH5, true);
  registerFlowForm("leaveWithDraft", leaveH5, true);
  registerFlowForm("lowcode", customVform);
}
